import { SectorColours } from '../base-styles/sector-colours';
import { Sector } from '../model/sector';

export function sectorToDarkColour(sector: Sector): string {
  if (sector === Sector.Transport) {
    return SectorColours.transportColourDark;
  }
  if (sector === Sector.Industry) {
    return SectorColours.industryColourDark;
  }
  if (sector === Sector.Agriculture) {
    return SectorColours.agricultureColourDark;
  }
  if (sector === Sector.Energy) {
    return SectorColours.energyColourDark;
  }
  if (sector === Sector.Other) {
    return SectorColours.otherColourDark;
  }
  if (sector === Sector.Emission) {
    return SectorColours.emissionColourDark;
  }
  return SectorColours.unknownColourDark;
}
